#import '../fragments/onboarding-module-fragment.graphql'
#import '../fragments/onboarding-quotes-fragment.graphql'

query GetTrialOnboarding {
    trialOnboarding {
        tailoredModules {
            ...OnboardingModuleFragment
        }
        additionalModules {
            ...OnboardingModuleFragment
        }
        onboardingQuotes {
            ...OnboardingQuotesFragment
        }
    }
}
